import { render, staticRenderFns } from "./basket-question-list-pop.vue?vue&type=template&id=40aa2afe&"
import script from "./basket-question-list-pop.vue?vue&type=script&lang=js&"
export * from "./basket-question-list-pop.vue?vue&type=script&lang=js&"
import style0 from "./basket-question-list-pop.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports